import UAParser from 'ua-parser-js/dist/ua-parser.min';
import { getNavigator, isClient } from './accessibility';
export var DEVICE_TYPES = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  SMART_TV: 'smarttv',
  CONSOLE: 'console',
  WEARABLE: 'wearable',
  BROWSER: undefined
};
export var BROWSER_TYPES = {
  CHROME: 'Chrome',
  FIREFOX: 'Firefox',
  OPERA: 'Opera',
  YANDEX: 'Yandex',
  SAFARI: 'Safari',
  INTERNET_EXPLORER: 'Internet Explorer',
  EDGE: 'Edge',
  CHROMIUM: 'Chromium',
  IE: 'IE',
  MOBILE_SAFARI: 'Mobile Safari'
};
export var OS_TYPES = {
  IOS: 'iOS',
  ANDROID: 'Android',
  WINDOWS_PHONE: 'Windows Phone'
};

var isIOS13Check = function isIOS13Check() {
  var nav = getNavigator();
  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};

export var getUADeviceType = function getUADeviceType() {
  // According to:
  // https://github.com/duskload/react-device-detect/blob/master/src/components/helpers/types.js
  // https://github.com/duskload/react-device-detect/blob/master/src/components/helpers/selectors.js
  var UA = isClient() ? new UAParser() : null;
  var browser = isClient() ? UA.getBrowser() : {};
  var device = isClient() ? UA.getDevice() : {};
  var os = isClient() ? UA.getOS() : {};
  return {
    isMobile: isClient() && device.type === DEVICE_TYPES.MOBILE,
    isTablet: isClient() && device.type === DEVICE_TYPES.TABLET,
    isIE: isClient() && (browser.name === BROWSER_TYPES.INTERNET_EXPLORER || browser.name === BROWSER_TYPES.IE),
    isAndroid: isClient() && os.name === OS_TYPES.ANDROID,
    isWindowsPhone: isClient() && os.name === OS_TYPES.WINDOWS_PHONE,
    isIOS: isClient() && os.name === OS_TYPES.IOS,
    isIOS13: isClient() && isIOS13Check()
  };
};